<template>
  <div class="p-a-4">
    <ticket-item
      v-for="(ticket, index) in tickets"
      :key="index"
      :ticket="ticket"
      :add="true"
      :type="type"
    />
  </div>
</template>

<script>

import moment from 'moment';

import TicketItem from './TicketItem.vue';

export default {
  components: {
    TicketItem,
  },
  props: {
    type: {
      type: String,
      default: 'broadcast',
      validator: value => ['broadcast', 'video'].indexOf(value) !== -1,
    },
  },
  computed: {
    /**
     * Return the current item in store
     * @returns {?Object}
     */
    item() {
      if (this.type === 'video') {
        return this.$store.getters['Video/current'];
      }

      return this.$store.getters['Broadcast/current'];
    },
    tickets() {
      const {
        item: {
          id,
          scheduled_start_time,
        },
      } = this;

      return this.$store.getters['Products/allStreams'].filter((t) => {
        const ticket = { ...t };
        if (typeof ticket.access.expires_at !== 'undefined') {
          if (moment(ticket.access.expires_at).isBefore(new Date())) {
            ticket.expired = true;
          } else if (moment(ticket.access.expires_at).isBefore(scheduled_start_time)) {
            ticket.expires_soon = true;
          }
        }


        if (!ticket.access.content.includes(`${this.type === 'video' ? 'video' : 'live'}:${id}`) && !ticket.access.content.includes(`${this.type === 'video' ? 'video' : 'live'}:*`)) {
          return ticket;
        }

        return null;
      });
    },
  },
};
</script>
